import {createContext, ReactNode, useState} from 'react';
import {InnovEnergyUser} from '../interfaces/UserTypes';

// Define the shape of the context
interface UserContextType {
  currentUser?: InnovEnergyUser;
  setUser: (user: InnovEnergyUser, rememberMe?: boolean) => void;
  removeUser: () => void;
}

// Create the context.
export const UserContext = createContext<UserContextType | undefined>(
  undefined
);

const getStoredUser = (): InnovEnergyUser | null => {
  const data = localStorage.getItem('currentUser') || sessionStorage.getItem('currentUser');
  return data ? JSON.parse(data) : null;
};

// Create a UserContextProvider component
export const UserContextProvider = ({ children }: { children: ReactNode }) => {
  const [currentUser, setUser] = useState<InnovEnergyUser>(getStoredUser);

  const saveUser = (new_user: InnovEnergyUser, rememberMe?: boolean) => {
    setUser(new_user);
    const storage = rememberMe !== undefined
      ? (rememberMe ? localStorage : sessionStorage)
      : (localStorage.getItem('currentUser') ? localStorage : sessionStorage);
    storage.setItem('currentUser', JSON.stringify(new_user));
  };

  const deleteUser = () => {
    localStorage.removeItem('currentUser');
    sessionStorage.removeItem('currentUser');
  };

  return (
    <UserContext.Provider
      value={{
        currentUser,
        setUser: saveUser,
        removeUser: deleteUser
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;
